import { concat, map, pathOr, pipe, prop, uniq, uniqBy } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text } from '../presentation/Text'
import { WrapLoading } from '../helpers/Loading'
import { getQueryName } from '../../utils/apollo/_helpers/graphql'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import Link from './Link'

const combineRawObjectsResultWithValue = value => response => {
  return pipe(
    concat(value || []), //
    uniqBy(prop('id'))
  )(response)
}

const combineObjectsResultWithValue = value => response => {
  return pipe(
    map(origin => ({ origin, value: origin.id, label: origin.name })),
    concat(value || []),
    uniqBy(prop('value'))
  )(response)
}

const combineIdsWithValue = value => response => {
  return pipe(
    map(prop('id')), //
    concat(value || []),
    uniq
  )(response)
}

const combineValues = (value, useOnlyIds, useRawValues) => response => {
  if (useOnlyIds) return combineIdsWithValue(value)(response)
  if (useRawValues) return combineRawObjectsResultWithValue(value)(response)
  return combineObjectsResultWithValue(value)(response)
}

const LazySelectAllLinkApollo = ({
  query,
  value,
  variables,
  onSelect,
  setValue,
  children,
  client,
  useOnlyIds,
  useRawValues
}) => {
  const { t } = useTranslation()
  const [loading, setLoading] = React.useState(false)
  const queryName = getQueryName(query)

  const call = usePromiseQuery(query, {
    variables,
    client
  })

  const handleSelectAll = () => {
    setLoading(true)
    return call()
      .then(
        pipe(
          pathOr([], ['data', queryName]), //
          combineValues(value, useOnlyIds, useRawValues),
          onSelect || setValue
        )
      )
      .finally(() => setLoading(false))
  }

  return (
    <WrapLoading loading={loading}>
      <Link onClick={handleSelectAll}>
        {!!children ? (
          children
        ) : (
          <Text size="xsmall" onClick={handleSelectAll}>
            {t('selectAll')}
          </Text>
        )}
      </Link>
    </WrapLoading>
  )
}

export default LazySelectAllLinkApollo
